import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/advanceSummaryCard.module.scss';

const TONE_CLASSES = {
    default: '',
    fee: styles.rowFee,
    highlight: styles.rowHighlight,
};

function AdvanceSummaryKpiGroup({ label, rows = [] }) {
    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>
                {label}
            </Text>
            {rows.map((row) => {
                const toneClass = TONE_CLASSES[row.tone] || TONE_CLASSES.default;
                const rowClass = `${styles.row} ${toneClass}`.trim();
                return (
                    <div key={row.label} className={rowClass}>
                        <Text as="span" size="s" className={styles.rowLabel}>
                            {row.label}
                        </Text>
                        <Text as="span" size="s" className={styles.rowValue}>
                            {row.value}
                        </Text>
                    </div>
                );
            })}
        </section>
    );
}

export default AdvanceSummaryKpiGroup;
